
import styles from "./SpectacleDetailGallery.module.css";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
import "@fancyapps/ui/dist/carousel/carousel.css";


const SpectacleDetailGallery = ({ Galerie }) => {

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  useEffect(() => {
    const handleResize = () => {
      window.requestAnimationFrame(() => {
        setIsMobile(window.innerWidth <= 991);
      });
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    Fancybox.bind("[data-fancybox]", {
      Thumbs: false,
      zIndex: 10000,
      Image: {
        zoom: true,
        clickToClose: true,
        wheel: "slide",
      },
    });

    return () => {
      Fancybox.destroy();
    };
  }, [isMobile]);

  useEffect(() => {
    if (!isMobile) return;

    const container = document.getElementById("myCarousel");
    if (!container) return;

    const options = {
      infinite: false,
      slidesPerView: 1.5,
      center: false,
      transition: "slide",
      Dots: false,
      Navigation: false,
      spacing: 10,
    };

    // Create Carousel instance and store reference for cleanup
    const carouselInstance = new Carousel(container, options);

    return () => {
      if (carouselInstance) {
        carouselInstance.destroy();
      }
    };
  }, [isMobile]);

  if (!Galerie || Galerie.length === 0) {
    return null; // No gallery images to display
  }

  return (
    <div className={styles.spectacleDetailGalerie}>
      <h3>Galerie</h3>
      <ul className={`${styles.galerie} ${isMobile ? "f-carousel" : ""} `} id="myCarousel">
        {Galerie.map((image) => (
          <li key={image.id} className={isMobile ? "f-carousel__slide" : ""}>
            <Link to={image.path} data-fancybox="gallery" data-caption={image.name}>
              <img src={image.path} alt={image.name} width={265} height={180} />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}


export default SpectacleDetailGallery;
